// query string params
export const PageParamName = "page";
export const OrderStateParamName = "order_state";

export const OrderState = {
  InProgress: "InProgress",
  History: "History"
};

export const OrderStatus = {
  AwaitingPayment: "AwaitingPayment",
  Ordered: "Ordered",
  InProduction: "InProduction",
  Sent: "Sent",
  Cancelled: "Cancelled"
};

export const InternalOrderStatus = {
  Received: "Received",
  Confirmed: "Confirmed",
  ProductionStarted: "ProductionStarted",
  ProductionCompleted: "ProductionCompleted",
  Dispatched: "Dispatched",
  Cancelled: "Cancelled"
};

export const OrderStatusMapping = [
  {
    status: OrderStatus.AwaitingPayment,
    internal: [InternalOrderStatus.Received],
    color: "cyan"
  },
  {
    status: OrderStatus.Ordered,
    internal: [InternalOrderStatus.Confirmed],
    color: "cyan"
  },
  {
    status: OrderStatus.InProduction,
    internal: [InternalOrderStatus.ProductionStarted, InternalOrderStatus.ProductionCompleted],
    color: "cyan"
  },
  {
    status: OrderStatus.Sent,
    internal: [InternalOrderStatus.Dispatched],
    color: "cyan"
  },
  {
    status: OrderStatus.Cancelled,
    internal: [InternalOrderStatus.Cancelled],
    color: "red"
  }
];
